(function () {
  if (window.sjRakhiCoinInit) return;
  window.sjRakhiCoinInit = true;

  var CAMPAIGN_END = new Date('2026-08-21T23:59:00+05:30');

  // One-time cleanup: the original "999 fine silver coin" gift mechanism was
  // replaced by the Regular Rakhi / Hamper Box tiers below. Carts that already
  // had the coin auto-added before this change won't know to remove it on
  // their own, since it's no longer part of any tier — so it's swept out
  // unconditionally, independent of subtotal eligibility.
  var LEGACY_COIN_VARIANT_ID = 42338033074231;

  var TIERS = [
    {
      key: 'rakhi',
      thresholdCents: 299900, // ₹2,999
      label: 'Free Regular Rakhi',
      getVariants: function () {
        return fetch('/collections/regular-rakhi-gift-pool/products.json?limit=50')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var variants = [];
            (data.products || []).forEach(function (p) {
              (p.variants || []).forEach(function (v) {
                variants.push({ id: v.id, available: v.available });
              });
            });
            return variants;
          })
          .catch(function () { return []; });
      },
    },
    {
      key: 'hamper',
      thresholdCents: 499900, // ₹4,999
      label: 'Free Hamper Box',
      getVariants: function () {
        return Promise.resolve([{ id: 42340063281207, available: true }]);
      },
    },
  ];

  var syncing = false;
  var pendingResync = false;
  var tierVariantsCache = {};

  function getTierVariants(tier) {
    if (!tierVariantsCache[tier.key]) {
      tierVariantsCache[tier.key] = tier.getVariants();
    }
    return tierVariantsCache[tier.key];
  }

  // Rakhi purchases themselves should never count toward unlocking these
  // gifts — only non-Rakhi purchases should. Fetched once and cached.
  var rakhiCollectionIdsPromise = null;
  function getRakhiCollectionIds() {
    if (!rakhiCollectionIdsPromise) {
      rakhiCollectionIdsPromise = fetch('/collections/rakhi/products.json?limit=50')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var ids = [];
          (data.products || []).forEach(function (p) {
            (p.variants || []).forEach(function (v) { ids.push(v.id); });
          });
          return ids;
        })
        .catch(function () { return []; });
    }
    return rakhiCollectionIdsPromise;
  }

  function refreshUI() {
    fetch(window.Shopify.routes.root + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.querySelector('.shopify-section');
        var target = document.getElementById('cart-icon-bubble');
        if (source && target) target.innerHTML = source.innerHTML;
      })
      .catch(function () {});

    var mainCartItems = document.getElementById('main-cart-items');
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartItems || mainCartFooter) {
      var ids = [mainCartItems, mainCartFooter].filter(Boolean).map(function (el) { return el.dataset.id; });
      fetch(window.location.pathname + '?sections=' + ids.join(','))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          [mainCartItems, mainCartFooter].forEach(function (el) {
            if (!el || !sections[el.dataset.id]) return;
            var doc = new DOMParser().parseFromString(sections[el.dataset.id], 'text/html');
            var source = doc.querySelector('.js-contents');
            var target = el.querySelector('.js-contents');
            if (source && target) target.innerHTML = source.innerHTML;
          });
        })
        .catch(function () {});
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active')) {
      fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('#CartDrawer');
          var target = document.getElementById('CartDrawer');
          if (source && target) target.innerHTML = source.innerHTML;
        })
        .catch(function () {});
    }
  }

  function realSubtotal(cart, excludedIds) {
    // Use original_line_price (pre-discount), and exclude every gift-tier
    // item plus every Rakhi-collection item, so free gifts never help cross
    // a later threshold and Rakhi purchases never unlock their own gifts —
    // only non-Rakhi purchases count toward the ₹ thresholds.
    return cart.items.reduce(function (sum, item) {
      return excludedIds.indexOf(item.variant_id) > -1 ? sum : sum + item.original_line_price;
    }, 0);
  }

  function syncGifts() {
    if (new Date() > CAMPAIGN_END) return;
    if (syncing) { pendingResync = true; return; }
    syncing = true;

    Promise.all(
      [fetch('/cart.js').then(function (r) { return r.json(); }), getRakhiCollectionIds()].concat(
        TIERS.map(function (tier) { return getTierVariants(tier); })
      )
    )
      .then(function (results) {
        var cart = results[0];
        var rakhiIds = results[1];
        var tierVariantLists = results.slice(2); // same order as TIERS

        var excludedIds = rakhiIds.slice();
        tierVariantLists.forEach(function (list) {
          list.forEach(function (v) { excludedIds.push(v.id); });
        });

        var subtotal = realSubtotal(cart, excludedIds);
        var action = null;

        var legacyCoinLine = cart.items.find(function (item) { return item.variant_id === LEGACY_COIN_VARIANT_ID; });
        if (legacyCoinLine) {
          action = { type: 'change', body: { line: cart.items.indexOf(legacyCoinLine) + 1, quantity: 0 } };
        }

        for (var i = 0; !action && i < TIERS.length; i++) {
          var tier = TIERS[i];
          var variants = tierVariantLists[i];
          if (!variants.length) continue;

          var tierIds = variants.map(function (v) { return v.id; });
          var eligible = subtotal >= tier.thresholdCents;
          // Only ever treat a line as "the gift" if it carries our own _gift
          // property — matching by variant ID alone would also catch a
          // customer who manually added the same product to actually buy it,
          // and wrongly delete their purchase once synced.
          var giftLine = cart.items.find(function (item) {
            return tierIds.indexOf(item.variant_id) > -1 && item.properties && item.properties._gift;
          });

          if (eligible && !giftLine) {
            var toAdd = variants.find(function (v) { return v.available; });
            if (!toAdd) continue;
            action = {
              type: 'add',
              body: { items: [{ id: toAdd.id, quantity: 1, properties: { _gift: tier.label } }] },
            };
            break;
          }
          if (!eligible && giftLine) {
            action = {
              type: 'change',
              body: { line: cart.items.indexOf(giftLine) + 1, quantity: 0 },
            };
            break;
          }
          // Defensive: never more than one of a given gift.
          if (eligible && giftLine && giftLine.quantity > 1) {
            action = {
              type: 'change',
              body: { line: cart.items.indexOf(giftLine) + 1, quantity: 1 },
            };
            break;
          }
        }

        if (!action) return;
        var url = action.type === 'add' ? '/cart/add.js' : '/cart/change.js';
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(action.body),
        }).then(function () {
          refreshUI();
          // Another tier may now need evaluating (e.g. hamper box right after rakhi).
          pendingResync = true;
        });
      })
      .catch(function (e) { console.error('Rakhi gift sync failed', e); })
      .finally(function () {
        syncing = false;
        if (pendingResync) {
          pendingResync = false;
          syncGifts();
        }
      });
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartMutation = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
    var isOwnGiftMutation = init && init.body && String(init.body).indexOf('"_gift"') !== -1;
    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartMutation && !isOwnGiftMutation) {
        setTimeout(syncGifts, 250);
      }
      return response;
    });
  };

  document.addEventListener('DOMContentLoaded', syncGifts);
})();
